var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16335 3.26691L4.07789 3.96402C4.7377 2.43516 5.69431 1.25861 6.68412 0.707183C4.88638 0.615496 3.14453 1.40018 2.02423 2.80341C1.89879 2.96091 1.97435 3.19809 2.16335 3.26691ZM4.64301 4.1699L9.11446 5.79794C9.78496 3.52209 9.46509 1.45436 8.31516 1.03587C8.17641 0.985242 8.03148 0.960868 7.88223 0.960868C6.79436 0.961055 5.47719 2.25779 4.64301 4.1699ZM9.77764 1.83442C9.89427 2.14004 9.9807 2.48316 10.0251 2.86922C10.1328 3.80465 9.99852 4.89851 9.66983 6.00006L11.5939 6.70056C11.7831 6.76937 11.9935 6.63624 11.9984 6.43487C12.0419 4.6407 11.2126 2.92041 9.77764 1.83442ZM10.4999 9.09959H6.01981L7.23742 5.75313L6.10981 5.34251L4.74295 9.0994H0.299997C0.134249 9.0994 0 9.23365 0 9.39959V9.99977C0 10.1655 0.134249 10.3 0.299997 10.3H10.4999C10.6656 10.3 10.7999 10.1655 10.7999 9.99977V9.39959C10.7999 9.23384 10.6656 9.09959 10.4999 9.09959Z",
    fill: "#F5F8FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.12edd21932d7c0bea22e5883e4592119.svg";
export { ForwardRef as ReactComponent };